import styled from '@emotion/styled';
import { TcolorsPaletteFromBO } from '../../types';

export const StyledContainer = styled('div')(() => ({
  display: 'flex',
  maxWidth: '80%',
  width: '80%',
  alignItems: 'center',
}));

export const StyledLogoLink = styled('a')(() => ({
  width: '20%',
  boxSizing: 'border-box',
}));

export const StyledMenuItemsAndArrowsContainer = styled('div')(() => ({
  display: 'flex',
  maxWidth: '75%',
  width: '75%',
  alignItems: 'center',
}));

export const StyledMenuItemsAndArrows = styled('div')(() => ({
  display: 'flex',
  maxWidth: '90%',
  alignItems: 'center',
  position: 'relative',
}));

export const StyledOpacityOverlay = styled('div')(
  ({ position }: { position: string }) => ({
    position: 'absolute',
    left: position === 'right' ? '94%' : 0,
    width: '6%',
    height: '100%',
    opacity: 0.7,
    backgroundColor: 'white',
    zIndex: 1000,
  }),
);

export const StyledArrowContainer = styled('div')(() => ({
  width: '5%',
  height: 40,
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledEmptySpace = styled('div')(() => ({
  width: '5%',
  height: 40,
}));

export const StyledMenuItemsContainer = styled('div')(() => ({
  padding: 16,
  width: '100%',
  overflow: 'hidden',
  verticalAlign: 'center',
}));

export const StyledMenuItems = styled('div')(() => ({
  display: 'flex',
  gap: 16,
  alignItems: 'center',
  fontSize: 16,
}));

export const StyledLink = styled('a')(
  ({
    colorsPaletteFromBO,
    isCurrentUrl,
  }: {
    colorsPaletteFromBO: TcolorsPaletteFromBO;
    isCurrentUrl: boolean;
  }) => ({
    color: '#4e4e4e',
    display: 'block',
    position: 'relative',
    textDecoration: 'none',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    fontWeight: isCurrentUrl ? 'bold' : 'normal',
    '&:hover': {
      fontWeight: 'bold',
      '&:after': {
        transform: 'scaleX(1)',
      },
    },
    '&:after': {
      backgroundColor: colorsPaletteFromBO.main,
      bottom: '-0.5rem',
      content: '""',
      height: '0.2rem',
      left: 0,
      position: 'absolute',
      transform: isCurrentUrl ? 'scaleX(1)' : 'scaleX(0)',
      transition: isCurrentUrl ? 'none' : 'transform 0.3s ease-in-out',
      width: '100%',
    },
  }),
);
